import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    textTransform: 'initial',
  },
  container: {
    backgroundColor: '#ffffff',
    borderRadius: '4px 4px 4px 4px',
    padding: theme.spacing(3),
    width: '100%',
  },
  row: {
    alignItems: 'center',
    //justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    width: 260,
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  desc: {
    width: '30%',
    fontSize: 16,
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  textBox: {
    marginTop: theme.spacing(3),
    fontSize: 12,
    maxWidth: 580,
    color: 'rgb(0 0 0 / 54%)',
  },
  btn: {
    '&.MuiButton-root': {
      textTransform: 'initial',
    },
    //marginRigth: theme.spacing(3),
    margin: theme.spacing(2, 3, 0, 0),
    fontSize: 14,

    background: '#5081FF',
    color: 'white',
    padding: theme.spacing(1, 5),

    whiteSpace: 'nowrap',
  },
}));
